// NO 'use client' here

import {Autoplay, Keyboard, Navigation, Pagination} from "swiper/modules";
import {on} from "next/dist/client/components/react-dev-overlay/pages/bus";

export type ArticleImage = {
    url: string;
    alt?: string;
    width: number;
    height: number;
    classes?: string;
}
export type Article = {
    id: number;
    urlSlug: string;
    thumbnailUrl: string | null;
    title: string;
    metaDescription: string;
    metaKeywords: string;
    metaImg?: string | null;
    shortContent: string;
    content: string;
    createdAt: string;
    tags?: string[];
    featured: boolean;
    images: Record<string, ArticleImage>;
};

export interface ArticlesShortProps {
    classes?: string;
    tags?: string[];
    limit?: number;
    title?: string;
    articles?: Article[];
    onlyFeatured?: boolean;
}
export const getArticleImagePath = (img: string | null) =>
    img ? `/assets/imgs/data/${img}` : '---no-default-allowed';

export const formatArticleData = (iso: string) => {
    try {
        return new Intl.DateTimeFormat(undefined, {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
        }).format(new Date(iso));
    } catch {
        return '';
    }
};
export function filterAndSortArticles(data: Article[]): Article[] {
    return (data || [])
        .sort(
            (a, b) =>
                new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
}

export async function fetchArticle(slug: string, data: Article[]): Promise<Article | null> {
    return (
        data.find(
            (n) => n.urlSlug === slug
        ) || null
    );
}



export function filterAndLimitArticles(
    list: Article[],
    tags?: string[],
    limit?: number,
    onlyFeatured?: boolean,
): Article[] {
    let items = list;
    items = items.filter((item) => {
        const itemTags = item.tags || [];
        let tagsCheck = (tags && tags.length) ? tags.every((t) => itemTags.includes(t)) : true;
        let filtersCheck = onlyFeatured ? item.featured : true;
        return tagsCheck && filtersCheck;
    });

    if (typeof limit === "number") {
        items = items.slice(0, limit);
    }
    return items;
}


export const blogPostsSwiperOptions = {
    slidesPerView: 3,
    spaceBetween: 20,
    slidesPerGroup: 1,
    centeredSlides: false,
    loop: true,
    autoplay: { delay: 4000 },
    breakpoints: {
        1200: { slidesPerView: 3 },
        992: { slidesPerView: 3 },
        768: { slidesPerView: 2 },
        576: { slidesPerView: 1 },
        0: { slidesPerView: 1 },
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
    },
    modules: [Keyboard, Autoplay, Pagination, Navigation],
};